// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { times16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-times': IconTimes;
    }
}

/**
 * The icon component for the 'times' icon
 */
export class IconTimes extends IconSvg {
    public constructor() {
        super(times16X16);
    }
}

registerIconSvg('icon-times', IconTimes);
export const iconTimesTag = 'nimble-icon-times';
